import * as React from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { IState } from '../../reducers';

import * as auth from '../../app/Auth/Auth';
import { getEnvironment } from '../../utils/envResolver';

import './Header.css';

import Logo from '../../assets/spinverse_spinbase_logo_color6.png';

import { ReactComponent as UserIcon } from '../../assets/user--icon.svg';

interface IProps {
  user: auth0.AdfsUserProfile;
  hideNav?: boolean
}

const Header: React.FC<IProps> = ({ user, hideNav }) => {
  const [isEmailVerified, setIsEmailVerified] = React.useState<boolean>(false);
  const location = useLocation();

  React.useEffect(() => {
    const emailVerified = localStorage.getItem('isEmailVerified');
    if (emailVerified) {
      setIsEmailVerified(JSON.parse(emailVerified));
    }
  }, [user]);

  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    auth.logout();
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header>
      <a href="https://spinbase.eu/" target="_blank" rel="noreferrer">
        <img src={Logo} className="header__logo" alt="Spinverse Spinbase" title="Spinverse Spinbase" />
      </a>
      {getEnvironment() !== 'prod' && (
        <span style={{ color: 'red', fontSize: '16px', fontWeight: 'bold' }}>
          {getEnvironment()} Environment
        </span>
      )}
      {auth.isAuthenticated() && !hideNav ? (
        <nav>
          <Link to="/" className={isActive('/')}>Search</Link>
          {/* QA tools is a separate app served under /qatools/ on the same host */}
          <a href="/qatools/" target="_blank" rel="noopener noreferrer">
            QA tools
          </a>
          <Link
            to="/analytics"
            className={isActive('/analytics')}
            style={
              auth.hasTrialExpired() || !isEmailVerified
                ? { pointerEvents: 'none' }
                : { pointerEvents: 'auto' }
            }
          >
            Analytics
          </Link>
          <HelpMenu />
          {user.picture ? (
            <Link to="/profile" className="header__profile">
              <img src={user.picture} alt={user.name} />
            </Link>
          ) : (
            <Link to="#" className="header__profile">
              <UserIcon className="user_icon" />
            </Link>
          )}
          <a href="/logout" className="header__logout" onClick={handleLogout}>
            Log out
          </a>
        </nav>
      ) : null}
    </header>
  );
};

const mapStateToProps = ({ user }: IState) => {
  return { user };
};

export default connect(mapStateToProps)(Header);

const HelpMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();

  const handleOpenMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="menu__layout">
      {isOpen && <button onClick={handleOpenMenu} className="background-button" />}
      <div onMouseOver={handleOpenMenu} className="menu__button">
        Help
      </div>
      {isOpen ? (
        <div onMouseLeave={handleOpenMenu}>
          <div className="help__menu__tooltip-arrow" />

          <div className="help__menu">
            <Link to="/about" className={`menu__url ${isActive('/about')}`}>About</Link>
            <a
              className="menu__url"
              href="https://www.spinverse.com/spinbase/support"
              target={'blank'}
              onClick={handleOpenMenu}
            >
              Support
            </a>

            <a
              className="menu__url"
              href="mailto:helpdesk@spinbase.eu"
              target={'blank'}
              onClick={handleOpenMenu}
            >
              Contact
            </a>
          </div>
        </div>
      ) : (
        <div className="" />
      )}
    </div>
  );
};
